import React, { useState, useEffect, useRef } from 'react';
import cx from 'classnames';
import { CloseIcon } from '@wkda/icons';
import { useCookie } from '../hooks/useCookies';
import { useGetSelfEvaBanners } from '../hooks/useDataHooks';
import RawContent from '../RawContent';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const COOKIE_BANNER_COOKIE = '_wca';
const COVID_BANNER_COOKIE = '_wcb';
export function CookieBanner() {
  const {
    data: bannerData
  } = useGetSelfEvaBanners();
  const {
    isCookieSet,
    setBannerCookie
  } = useBannerCookies(COOKIE_BANNER_COOKIE);
  const [isOpen, setIsOpen] = useState(!isCookieSet);
  const setBannerCookieRef = useRef(setBannerCookie);
  useEffect(() => {
    setBannerCookieRef.current = setBannerCookie;
  });
  useEffect(() => {
    setBannerCookieRef.current();
  }, []);
  if (isOpen && bannerData && bannerData.cookieBanner) {
    return /*#__PURE__*/_jsx("div", {
      className: cx('info-banner', 'info-banner--cookie'),
      children: /*#__PURE__*/_jsx("div", {
        className: "info-banner__container container",
        children: /*#__PURE__*/_jsxs("div", {
          className: "info-banner__content",
          children: [/*#__PURE__*/_jsx(RawContent, {
            content: bannerData.cookieBanner,
            id: "js-cookie-banner",
            "data-qa-selector": "cms-info-cookie-banner",
            className: "info-banner-cookie__render-content"
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "btn btn-link info-banner__button",
            onClick: e => {
              e.preventDefault();
              setIsOpen(false);
            },
            children: /*#__PURE__*/_jsx(CloseIcon, {
              className: "info-banner__icon",
              width: "20",
              height: "20"
            })
          })]
        })
      })
    });
  }
  return null;
}
export function CovidBanner() {
  const {
    data: bannerData
  } = useGetSelfEvaBanners();
  const {
    isCookieSet,
    setBannerCookie
  } = useBannerCookies(COVID_BANNER_COOKIE);
  if (!isCookieSet && bannerData && bannerData.covidBanner) {
    return /*#__PURE__*/_jsx("div", {
      className: cx('info-banner', 'info-banner--covid'),
      children: /*#__PURE__*/_jsx("div", {
        className: "info-banner__container container",
        children: /*#__PURE__*/_jsxs("div", {
          className: "info-banner__content",
          children: [/*#__PURE__*/_jsx(RawContent, {
            content: bannerData.covidBanner,
            id: "js-covid-banner",
            "data-qa-selector": "cms-info-covid-banner"
          }), /*#__PURE__*/_jsx("button", {
            type: "button",
            className: "btn btn-link info-banner__button",
            onClick: e => {
              e.preventDefault();
              setBannerCookie();
            },
            children: /*#__PURE__*/_jsx(CloseIcon, {
              className: "info-banner__icon",
              width: "20",
              height: "20"
            })
          })]
        })
      })
    });
  }
  return null;
}

/**
 *
 * @param {string} cookieName
 * @returns {{isCookieSet: boolean, setBannerCookie: () => void}}
 */
function useBannerCookies(cookieName) {
  const {
    cookies,
    setCookie
  } = useCookie([cookieName]);
  const cookie = cookies[cookieName];
  const isCookieSet = cookie === 'true';
  function setBannerCookie() {
    let now = new Date();
    now.setTime(now.getTime() + 365 * 2 * 24 * 60 * 60 * 1000);
    setCookie(cookieName, true, {
      path: '/',
      expires: now
    });
  }
  return {
    isCookieSet,
    setBannerCookie
  };
}